import { useLocalStorage } from '@mantine/hooks';
import { whereConnectionStatusDefault } from '@vrplatform/ui-common';
import { useEffect } from 'react';
import { useQuery } from '../graphql';
import { useTeam } from '../hooks/team';

export const STORYBOOK_ACCOUNTING_CONNECTIONS_QUERY_KEY =
  'onboarding-accounting-connections';

function useConnectionsQuery() {
  const [{ id: teamId }] = useTeam();

  return useQuery(
    (q, args) => {
      return q
        .connection({
          where: {
            status: whereConnectionStatusDefault,
            tenantId: { _eq: args.teamId },
            app: { category: { _eq: 'accountingPlatform' } },
          },
          order_by: [{ appId: 'asc_nulls_first' }],
        })
        .map((connection) => ({
          appId: connection.appId as string,
          name: connection.name,
          type: connection.app.type,
          category: connection.app.category,
          id: connection.id as string,
          icon: connection.app.iconRound,
        }));
    },
    {
      skip: !teamId,
      queryKey: ['connections'],
      storybookQueryKey: STORYBOOK_ACCOUNTING_CONNECTIONS_QUERY_KEY,
      keepPreviousData: true,
      variables: {
        teamId,
      },
    }
  );
}

export function useAccountingConnectionQuery() {
  const [{ id: teamId }] = useTeam();
  const { data: accountingPlatforms = [], ...queryData } =
    useConnectionsQuery();

  const [accounting, setAccounting] = useLocalStorage<string | undefined>({
    key: `${teamId}_acc`,
    defaultValue: accountingPlatforms[0]?.id,
  });

  useEffect(() => {
    if (!accountingPlatforms.find((platform) => platform.id === accounting)) {
      setAccounting(accountingPlatforms[0]?.id);
    }
  }, [accountingPlatforms, accounting, setAccounting]);

  return {
    accounting: accountingPlatforms.find(
      (platform) => platform.id === accounting
    ),
    setAccounting,
    accountingPlatforms,
    loading: queryData.isLoading,
  };
}
